import React from "react";
import styles from "./RejectedOrderModification.module.scss";
import WarningIcon from "../Icons/WarningIcon";

const RejectedOrderModification = () => {
  return (
    <div className={styles.rejectedOrderMainContainer}>
      <div className={styles.card}>
        <div className={styles.iconWrapper}>
          <WarningIcon width={40} height={40} />
        </div>
        <div className={styles.title}>Modification request rejected!</div>
        <div className={styles.bodyText}>
          The request to modify the order has been declined. Your current order
          remains unchanged and will be processed as originally placed.
        </div>
        <div className={styles.supportText}>
          You may reach out to our customer support team at{" "}
          <span className={styles.supportNumber}>1800-570-6262</span> for
          further assistance.
        </div>
      </div>
    </div>
  );
};

export default RejectedOrderModification;

